/**
 * TODO: Extract addition of placeholder to this module
 */
export default (droppable) => {
  const placeHolder = document.querySelector('.place-holder');
  if (placeHolder) droppable.removeChild(placeHolder);
};
